import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink, productInquiryMessage } from "../lib/brand";

const categoryLabel = {
  nuts: "Nuts",
  chocolates: "Chocolate",
  dry_fruits: "Dry Fruit",
  sweets: "Sweets",
};

export const ProductCard = ({ product, index = 0 }) => {
  const whatsappUrl = buildWhatsAppLink(productInquiryMessage(product.name));

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="reveal group bg-[#3B1E1A] rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(59,30,26,0.12)] hover:shadow-[0_18px_50px_rgba(59,30,26,0.25)] transition-shadow flex flex-col"
      style={{ transitionDelay: `${(index % 6) * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#2a1411]">
        <img
          src={product.image_url}
          alt={product.name}
          loading="lazy"
          className="zoom-img w-full h-full object-cover"
        />
        <span className="absolute top-3 left-3 text-[10px] tracking-[0.18em] uppercase bg-brand-gold text-brand-brown px-2.5 py-1 rounded-full font-semibold">
          {categoryLabel[product.category] || product.category}
        </span>
        {product.origin && (
          <span className="absolute top-3 right-3 text-[10px] tracking-wide bg-brand-brown/80 backdrop-blur text-brand-ivory px-2.5 py-1 rounded-full">
            {product.origin}
          </span>
        )}
      </div>

      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-serif-display text-xl text-brand-ivory leading-tight">
          {product.name}
        </h3>
        <p className="mt-2 text-sm text-brand-ivory/70 leading-relaxed flex-1">
          {product.description}
        </p>

        <a
          href={whatsappUrl}
          target="_blank"
          rel="noreferrer"
          data-testid={`product-buy-whatsapp-${product.id}`}
          className="mt-5 inline-flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#1DA851] text-white py-3 rounded-full text-sm font-semibold transition-all hover:shadow-lg"
        >
          <MessageCircle className="h-4 w-4" />
          Buy on WhatsApp
        </a>
      </div>
    </article>
  );
};
